import React from "react";
import "./element-course.scss";
import { findTarget, findRel } from "../../../shared/utils/stringUtilities";
import { GatsbyImage } from "gatsby-plugin-image";

const ElementCourse = (props: ElementCourseInterface) => {
  const { title, info, imageSrc, imageAlt, gtmMark, linkTo, date } = props;

  return (
    <a
      href={linkTo}
      className={`m-elem-course ${gtmMark}`}
      target={findTarget(linkTo)}
      rel={findRel(linkTo)}
    >
      <div className="m-elem-course__img">
        <GatsbyImage
          className={`${gtmMark}`}
          image={imageSrc}
          alt={imageAlt || "imagen lateral"}
        />
      </div>
      <div className={`m-elem-course__cont ${gtmMark}`}>
        <span className={`m-elem-course__pretitle ${gtmMark}`}>
          {title || "Consulta"}
        </span>
        {/* title &&
               <p className={`m-elem-course__title ${gtmMark}`}  > 
                  {title} 
               </p>
            */}
        {info && (
          <div className={`m-elem-course__info ${gtmMark}`}>
            <p>{info}</p>
          </div>
        )}
        {date && (
          <div className={`m-elem-course__date ${gtmMark}`}>
            <p>{date}</p>
          </div>
        )}
      </div>
    </a>
  );
};

interface ElementCourseInterface {
  title?: string;
  info?: any;
  imageSrc: any;
  imageAlt: string;
  preTitle?: string;
  gtmMark?: string;
  linkTo?: string;
  date?: string;
}

export default ElementCourse;
